import React, { useEffect } from 'react';

import {
  ArrowDownIcon,
  ArrowUpIcon,
  ButtonV2 as Button,
  TableCell,
  TableRow,
} from '@lp/ds-next';
import { get } from 'lodash/fp';

import { ExpandableRow } from './ExpandableRow';
import { HeadCell } from '@/features/changelog/types/changelog';

export function Row<T>({
  row,
  headCells,
  globalOpen = false,
}: {
  row: T;
  headCells: HeadCell[];
  globalOpen?: boolean;
}) {
  const [open, setOpen] = React.useState(globalOpen);

  const nbCells = headCells.length + 1;

  useEffect(() => setOpen(globalOpen), [globalOpen]);

  return (
    <React.Fragment>
      <TableRow
        sx={{
          '& > *': { borderBottom: 'unset !important' },
          cursor: 'pointer',
        }}
        onClick={() => setOpen(!open)}
        hover
      >
        <TableCell>
          <Button
            size="small"
            variant="flat"
            aria-label="expand row for more details"
            onClick={() => setOpen(!open)}
            icon={open ? ArrowUpIcon : ArrowDownIcon}
          />
        </TableCell>
        {headCells.map(({ path, formatter, render }, index) => {
          let cellContent: React.ReactNode;

          if (render) {
            cellContent = render(row);
          } else {
            const raw = get(path, row);
            const value = raw != null ? String(raw) : '';
            let formattedValue: React.ReactNode = value;

            if (formatter) {
              formattedValue = formatter(value);
            }

            cellContent = formattedValue || '-';
          }

          return (
            <TableCell
              key={index}
              align="right"
              sx={{ whiteSpace: 'nowrap', fontWeight: open ? 500 : 400 }}
            >
              {cellContent}
            </TableCell>
          );
        })}
      </TableRow>
      <ExpandableRow row={row} open={open} nbCells={nbCells} />
    </React.Fragment>
  );
}
